import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Dialog, Grid, Typography, IconButton } from '@mui/material';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import CentsLoader from 'components/common/centsLoader/CentsLoader';
import { ThemeCard } from '../themeCard';
import { CommonThemeEditor } from '../commonThemeEditor';
import { getAllThemesByBusinessId } from 'api/admin/businesses/businesses';
import { THEME_ELEMENTS } from 'utils/constants';

export const ThemeList = ({
  setThemeFromList,
  isThemeListOpened,
  setIsThemeListOpened,
  businessId,
  refreshStoreAndBusiness,
  setRequestResponse,
  setRequestError,
}) => {
  const [allThemes, setAllThemes] = useState([]);
  const [editableCommonTheme, setEditableCommonTheme] = useState(null);

  useEffect(() => {
    const getThemes = async () => {
      const {
        data: { themes: apiThemes },
      } = await getAllThemesByBusinessId(businessId);
      setAllThemes(apiThemes);
    };

    if (isThemeListOpened) {
      getThemes();
    }
  }, [isThemeListOpened]);

  const closeThemeList = async () => {
    setIsThemeListOpened(false);
  };

  return (
    <>
      <Dialog
        onClose={closeThemeList}
        open={isThemeListOpened}
        maxWidth="xl"
        classes={{ root: 'theme-list-container' }}
      >
        <MuiDialogTitle disableTypography>
          <Grid container justifyContent="space-between" alignItems="center">
            <Typography variant="h6">{THEME_ELEMENTS.themesList}</Typography>
            <IconButton onClick={closeThemeList}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </MuiDialogTitle>
        <MuiDialogContent className="content-container">
          {allThemes?.length ? (
            <Grid container alignItems="stretch" spacing={2}>
              {allThemes.map((theme) => (
                <ThemeCard
                  key={theme.appliedTo[0].id}
                  theme={theme}
                  setEditableCommonTheme={setEditableCommonTheme}
                  setThemeFromList={setThemeFromList}
                  closeThemeList={closeThemeList}
                />
              ))}
            </Grid>
          ) : (
            <CentsLoader />
          )}
        </MuiDialogContent>
      </Dialog>
      <CommonThemeEditor
        editableCommonTheme={editableCommonTheme}
        setEditableCommonTheme={setEditableCommonTheme}
        closeThemeList={closeThemeList}
        refreshStoreAndBusiness={refreshStoreAndBusiness}
        setRequestResponse={setRequestResponse}
        setRequestError={setRequestError}
      />
    </>
  );
};

ThemeList.propTypes = {
  setThemeFromList: PropTypes.func.isRequired,
  isThemeListOpened: PropTypes.bool,
  setIsThemeListOpened: PropTypes.func.isRequired,
  businessId: PropTypes.string,
  refreshStoreAndBusiness: PropTypes.func.isRequired,
  setRequestResponse: PropTypes.func.isRequired,
  setRequestError: PropTypes.func.isRequired,
};
